import React from 'react';

const BerlinFashionWeekGallery = () => {
  const photos = [
    { id: 1, src: '/images/portfolio/bfw1.jpg', alt: 'Berlin Fashion Week Coverage 1' },
    { id: 2, src: '/images/portfolio/bfw2.jpg', alt: 'Berlin Fashion Week Coverage 2' },
    { id: 3, src: '/images/portfolio/bfw3.jpg', alt: 'Berlin Fashion Week Coverage 3' },
    { id: 4, src: '/images/portfolio/bfw4.jpg', alt: 'Berlin Fashion Week Coverage 4' },
    { id: 5, src: '/images/portfolio/bfw5.jpg', alt: 'Berlin Fashion Week Coverage 5' },
    { id: 6, src: '/images/portfolio/bfw6.jpg', alt: 'Berlin Fashion Week Coverage 6' }
  ];

  return (
    <section className="bg-black py-20 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-gold mb-4">
            Berlin Fashion Week
          </h2>
          <p className="text-lg text-secondary font-sans max-w-2xl mx-auto">
            Social media coverage for The Garnette Report covering Berlin Fashion Week
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 lg:gap-6">
          {photos.map((photo) => (
            <div
              key={photo.id}
              className="relative overflow-hidden rounded-lg group cursor-pointer"
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          ))}
        </div>

        {/* Brand Collaborations Banner */}
        <div className="mt-16">
          <img
            src="/images/brands/brands-banner.png"
            alt="Brand Collaborations: TED, Berlin Fashion Week, BARE Berlin"
            className="w-full max-w-4xl mx-auto rounded-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default BerlinFashionWeekGallery;
